(function () {
  const config = window.zenceTokenConfig || {};
  const pointsEndpoint = config.pointsEndpoint || 'https://inc5shop.com/apps/ez/api/CustomerAvailablePoints';
  const rewardsNode = document.querySelector('[data-zence-header-points]');
  const triggerNode = document.querySelector('[data-zence-rewards-trigger]');
  const modalNode = document.querySelector('[data-zence-rewards-modal]');
  const formNode = document.querySelector('[data-zence-rewards-form]');
  const inputNode = document.querySelector('[data-zence-rewards-input]');
  const submitNode = document.querySelector('[data-zence-rewards-submit]');
  const messageNode = document.querySelector('[data-zence-rewards-message]');
  const closeNodes = document.querySelectorAll('[data-zence-rewards-close]');
  const sessionStorageKey = `zence_rewards_points_${window.location.hostname}`;
  let pointsPromise = null;
  let lastActiveElement = null;

  function digitsOnly(value) {
    return `${value || ''}`.replace(/\D/g, '');
  }

  function normalizeMobileNumber(value) {
    const rawValue = `${value || ''}`.trim();
    const onlyDigits = digitsOnly(rawValue);
    const countryCode = digitsOnly(config.countryCode || '');

    if (!onlyDigits) return '';

    if (countryCode && onlyDigits.startsWith(countryCode) && onlyDigits.length > countryCode.length) {
      return onlyDigits.slice(countryCode.length);
    }

    if (rawValue.startsWith('+') && onlyDigits.length > 10) {
      return onlyDigits.slice(-10);
    }

    return onlyDigits.length > 10 ? onlyDigits.slice(-10) : onlyDigits;
  }

  function resolveEasyId() {
    return normalizeMobileNumber(config.easyId);
  }

  function canUseSessionStorage() {
    try {
      return typeof window.sessionStorage !== 'undefined';
    } catch (_error) {
      return false;
    }
  }

  function readStoredPoints() {
    if (!canUseSessionStorage()) return null;

    try {
      const rawValue = window.sessionStorage.getItem(sessionStorageKey);
      return rawValue ? JSON.parse(rawValue) : null;
    } catch (_error) {
      return null;
    }
  }

  function writeStoredPoints(payload) {
    if (!canUseSessionStorage() || !payload) return;

    try {
      window.sessionStorage.setItem(sessionStorageKey, JSON.stringify(payload));
    } catch (_error) {
      // Ignore storage write failures.
    }
  }

  function setMessage(text, state) {
    if (!messageNode) return;

    messageNode.textContent = text || '';
    messageNode.classList.remove('is-error', 'is-success');

    if (state) {
      messageNode.classList.add(state);
    }
  }

  function setLoadingState(isLoading) {
    if (!submitNode) return;

    submitNode.disabled = isLoading;
    submitNode.textContent = isLoading ? 'Checking...' : 'Check points';
  }

  function getAvailablePoints(pointsData) {
    if (!pointsData || typeof pointsData !== 'object') return null;

    const possibleKeys = [
      'AvailablePoints',
      'availablePoints',
      'Available_Point',
      'available_point',
      'Points',
      'points'
    ];

    for (let index = 0; index < possibleKeys.length; index += 1) {
      const value = pointsData[possibleKeys[index]];

      if (value !== undefined && value !== null && `${value}` !== '') {
        return value;
      }
    }

    return null;
  }

  function updateHeaderPoints(pointsData) {
    if (!rewardsNode) return;

    const availablePoints = getAvailablePoints(pointsData);
    if (availablePoints === null) {
      rewardsNode.textContent = config.isLoggedIn && !resolveEasyId() ? '0 pts' : '0 pts';
      return;
    }

    rewardsNode.textContent = `${availablePoints} pts`;
  }

  function persistPoints(pointsData, mobileNumber) {
    const availablePoints = getAvailablePoints(pointsData);
    if (availablePoints === null) return;

    writeStoredPoints({
      mobileNumber: normalizeMobileNumber(mobileNumber),
      availablePoints
    });
  }

  function hydrateStoredPoints() {
    const storedPoints = readStoredPoints();
    if (!storedPoints) return false;

    const currentEasyId = config.isLoggedIn ? resolveEasyId() : '';
    const storedEasyId = normalizeMobileNumber(storedPoints.mobileNumber);

    if (config.isLoggedIn && currentEasyId && storedEasyId && storedEasyId !== currentEasyId) {
      return false;
    }

    updateHeaderPoints({
      AvailablePoints: storedPoints.availablePoints
    });
    return true;
  }

  function openModal() {
    if (!modalNode) return;

    lastActiveElement = document.activeElement;
    modalNode.hidden = false;
    modalNode.classList.add('is-open');
    document.body.classList.add('overflow-hidden');
    setMessage('');
    setLoadingState(false);

    if (inputNode && !config.isLoggedIn) {
      inputNode.value = '';
      inputNode.focus();
    }
  }

  function closeModal() {
    if (!modalNode) return;

    modalNode.classList.remove('is-open');
    modalNode.hidden = true;
    document.body.classList.remove('overflow-hidden');
    setLoadingState(false);

    if (lastActiveElement && typeof lastActiveElement.focus === 'function') {
      lastActiveElement.focus();
    }
  }

  async function fetchAvailablePoints(mobileNumber) {
    const easyId = normalizeMobileNumber(mobileNumber);
    if (!easyId) return null;

    const response = await fetch(pointsEndpoint, {
      method: 'POST',
      credentials: config.credentials || 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        EasyId: easyId,
        StoreName: config.storeName || 'inc5shoesonline.myshopify.com',
        ActivityCode: config.activityCode || 'RED01',
        StoreCode: config.storeCode || 'Ecom',
        CountryCode: config.countryCode || '91'
      })
    });

    const data = await response.json().catch(() => ({}));
    const returnCode = data.ReturnCode === undefined ? '0' : `${data.ReturnCode}`;

    if (!response.ok || returnCode !== '0') {
      throw new Error(data.ReturnMessage || 'Failed to fetch available points.');
    }

    return data;
  }

  async function ensureAvailablePoints() {
    const easyId = resolveEasyId();
    if (!easyId) return null;

    if (pointsPromise) return pointsPromise;

    pointsPromise = fetchAvailablePoints(easyId)
      .then((data) => {
        updateHeaderPoints(data);
        persistPoints(data, easyId);
        return data;
      })
      .finally(() => {
        pointsPromise = null;
      });

    return pointsPromise;
  }

  async function handleGuestLookup(event) {
    event.preventDefault();

    const mobileNumber = inputNode ? inputNode.value : '';
    const normalizedMobile = normalizeMobileNumber(mobileNumber);

    if (!normalizedMobile || normalizedMobile.length < 10) {
      setMessage('Enter a valid mobile number.', 'is-error');
      return;
    }

    setLoadingState(true);
    setMessage('');

    try {
      const data = await fetchAvailablePoints(normalizedMobile);
      const availablePoints = getAvailablePoints(data);

      updateHeaderPoints(data);
      persistPoints(data, normalizedMobile);

      if (availablePoints !== null) {
        setMessage(`Rewards found: ${availablePoints} pts`, 'is-success');
      } else {
        setMessage('No rewards found for this mobile number.', 'is-error');
      }
    } catch (error) {
      setMessage(error.message || 'Unable to fetch rewards right now.', 'is-error');
    } finally {
      setLoadingState(false);
    }
  }

  function handleTriggerClick() {
    if (config.isLoggedIn) return;
    openModal();
  }

  if (triggerNode) {
    triggerNode.addEventListener('click', handleTriggerClick);
  }

  closeNodes.forEach((node) => {
    node.addEventListener('click', closeModal);
  });

  if (modalNode) {
    modalNode.addEventListener('click', function (event) {
      if (event.target === modalNode) {
        closeModal();
      }
    });
  }

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modalNode && !modalNode.hidden) {
      closeModal();
    }
  });

  if (formNode) {
    formNode.addEventListener('submit', handleGuestLookup);
  }

  window.ZenceToken = {
    ensureAvailablePoints,
    openRewardsPopup: openModal
  };

  hydrateStoredPoints();

  if (config.isLoggedIn) {
    if (!resolveEasyId() && rewardsNode) {
      rewardsNode.textContent = '0 pts';
      return;
    }

    Promise.resolve()
      .then(ensureAvailablePoints)
      .catch((error) => {
        console.warn('EasyRewardz header points load failed', error);
      });
  }
})();
